const errorDefaults = {
  duration: 5000,
  message: 'Something is wrong. Try to enter correct data.',
  position: 'is-bottom',
}

const successDefaults = {
  duration: 5000,
  message: 'Success',
  position: 'is-bottom',
}

export function error(settings = {}) {
  return Object.assign({}, errorDefaults, settings, { type: 'is-danger' })
}

export function success(settings = {}) {
  return Object.assign({}, successDefaults, settings, { type: 'is-success' })
}



// WEBPACK FOOTER //
// ./src/lib/utils/toast.js